export const SITE_NAME = "Mestre da Comanda"

export const SITE_URL = (import.meta.env.VITE_SITE_URL || "https://mestredacomanda.com.br/").replace(/\/$/, "")

export const DEFAULT_OG_IMAGE = "../../src/assets/images/Logo2.png"

export const DEFAULT_SEO_DESCRIPTION =
  "Mestre da Comanda é o PDV para restaurante com comanda, cozinha, caixa, emissão de cupom fiscal (NFC-e), controle de rodízio e gestão financeira em um único SaaS para restaurante físico e delivery."

export const SEO_KEYWORDS = [
  "sistema para restaurante",
  "sistema de gestão para restaurante",
  "sistema de comanda para restaurante",
  "comanda eletrônica",
  "comanda física integrada",
  "software para restaurante",
  "sistema de delivery para restaurante",
  "gestão financeira para restaurante",
  "controle de pedidos e cozinha",
  "restaurante SaaS",
  "sistema para bar",
  "cardápio digital para bar",
  "cardápio digital público",
  "menu online para restaurante",
  "controle de mercadorias para restaurante",
  "renda extra como entregador",

  // PDV / frente de caixa
  "PDV para restaurante",
  "sistema de PDV para restaurante",
  "PDV para bar",
  "frente de caixa para restaurante",
  "ponto de venda para restaurante",
  "PDV com comanda eletrônica",
  "PDV online para restaurante",

  // cupom fiscal / nota fiscal
  "cupom fiscal para restaurante",
  "emissão de cupom fiscal",
  "sistema com emissão de NFC-e",
  "NFC-e para restaurante",
  "nota fiscal para restaurante",
  "sistema fiscal para restaurante",
  "PDV com cupom fiscal",
  "danfce",

  // rodízio
  "sistema de rodízio para restaurante",
  "controle de rodízio",
  "sistema para rodízio de churrasco",
  "sistema para rodízio de pizza",
  "sistema para rodízio de sushi",
  "gestão de rodízio para restaurante",
  "comanda para rodízio",

  // variações diretas
  "programa para restaurante",
  "aplicativo para restaurante",
  "sistema completo para restaurante",
  "software de gestão de restaurantes",
  "plataforma para restaurante",
  "ferramenta para restaurante",
  "sistema online para restaurante",

  // operação e pedidos
  "controle de pedidos restaurante",
  "gestão de pedidos cozinha",
  "sistema de pedidos online",
  "pedido digital restaurante",
  "automação de pedidos restaurante",
  "fluxo de pedidos cozinha",
  "gestão de comandas",

  // comandas
  "sistema de comanda eletrônica",
  "controle de comandas restaurante",
  "comanda digital para restaurante",
  "comanda via celular",
  "comanda integrada cozinha",
  "comanda para bar e restaurante",

  // cardápio
  "cardápio digital restaurante",
  "cardápio online interativo",
  "menu digital QR code",
  "cardápio via QR code",
  "menu digital para clientes",
  "cardápio eletrônico restaurante",
  "menu online bar",

  // delivery
  "sistema de delivery integrado",
  "gestão de delivery restaurante",
  "controle de entregas restaurante",
  "app de delivery próprio",
  "delivery sem taxa",
  "plataforma de delivery restaurante",
  "gestão de pedidos delivery",

  // financeiro
  "controle financeiro restaurante",
  "gestão de caixa restaurante",
  "fluxo de caixa restaurante",
  "controle de faturamento restaurante",
  "relatórios financeiros restaurante",
  "gestão de despesas restaurante",

  // estoque
  "controle de estoque restaurante",
  "gestão de mercadorias restaurante",
  "controle de insumos cozinha",
  "estoque automatizado restaurante",
  "controle de ingredientes restaurante",
  "gestão de estoque em tempo real",

  // bar
  "sistema para bar completo",
  "gestão de bar",
  "controle de pedidos bar",
  "cardápio digital bar QR code",
  "software para bar",
  "sistema de comanda para bar",

  // tecnologia / diferencial
  "automação para restaurante",
  "tecnologia para restaurantes",
  "inovação em restaurantes",
  "digitalização de restaurantes",
  "restaurante inteligente",
  "transformação digital restaurante",

  // público e aquisição
  "como melhorar vendas restaurante",
  "aumentar lucro restaurante",
  "reduzir custos restaurante",
  "otimizar operação restaurante",
  "melhor sistema para restaurante",
  "solução para restaurante pequeno",

  // SaaS e modelo
  "software SaaS para restaurante",
  "plataforma SaaS restaurante",
  "sistema em nuvem restaurante",
  "software online restaurante",
  "gestão na nuvem restaurante",

  // entregador / renda
  "ganhar dinheiro com delivery",
  "trabalhar como entregador",
  "renda extra com entregas",
  "app para entregadores",
  "como ser entregador",
  "plataforma para entregadores",

  // buscas locais/intenção
  "sistema para restaurante no brasil",
  "software para restaurantes brasileiros",
  "gestão para pequenos restaurantes",
  "sistema para lanchonete",
  "sistema para pizzaria",
  "sistema para hamburgueria",
  "sistema para food truck",
]

export const SUPPORTED_LOCALES = ["pt-BR"]

export const SEARCH_CONSOLE_VERIFICATION = import.meta.env.VITE_GOOGLE_SITE_VERIFICATION || ""
